  import React  from 'react';
import { Provider } from 'react-redux';
import store  from './redux/store';
import { ThemeProvider } from 'styled-components';
import Themes from './theme';
import Routes from './router/Route.main';
import 'antd/dist/antd.css'


const  App = ()=> {
 
  return (
  <Provider store={store}>
    <ThemeProvider theme={Themes.defaultTheme}>
      <Routes/>
      {/* <h3>Sunucuya erişilememektedir. </h3>
      <p>  İletişim için Lütfen Bize ulaşınız.</p>
      <a href='mailto:info@mitrotech.net?subject=Sunucu Aktivasyon'>info@mitrotech.net</a>
       */}
    </ThemeProvider>
  </Provider>
  );
}

export default App;
